<footer id="footer">
  <div>Service porté par l'IR Data Terra et développé par le BRGM</div>
  <nav class="navbar">
    <a href="https://www.data-terra.org/donnees-services/entrepot-de-donnees-data-terra/" target="_blank">A propos</a>
    <a href="mailto:entrepot@data-terra.org">Contact</a>
    <!--a routerLink="/public/home">API</a--><!--TODO : à décommenter avec l'issue #346-->
    <a href="/assets/documents/Mention-Légales-EasyData_V1.pdf" target="_blank">Mentions légales</a>
  </nav>
</footer>
